import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import ImageLoader from "../images/ImageLoader";
import PegRewardCardModal from './PegRewardCardModal';
import { Text } from '@sitecore-jss/sitecore-jss-react';

var PegRewardCard = function PegRewardCard(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      _props$userPegs = props.userPegs,
      userPegs = _props$userPegs === void 0 ? 0 : _props$userPegs; //state to show modal

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showPegRewardModal = _React$useState2[0],
      setShowPegRewardModal = _React$useState2[1];

  var hide = function hide() {
    setShowPegRewardModal(false);
  };

  var show = function show() {
    setShowPegRewardModal(true);
  };

  var Image = model.Image,
      Name = model.Name,
      RewardAmount = model.RewardAmount,
      Description = model.Description,
      PegsAvailableMessage = model.PegsAvailableMessage,
      PegsNeededMessage = model.PegsNeededMessage,
      ButtonAvailableReward = model.ButtonAvailableReward,
      ButtonUnavailableReward = model.ButtonUnavailableReward,
      Link = model.Link;
  var modalModel = {
    Image: Image,
    RewardAmount: RewardAmount,
    Name: Name,
    Description: Description,
    PegsAvailableMessage: PegsAvailableMessage,
    PegsNeededMessage: PegsNeededMessage,
    ButtonAvailableReward: ButtonAvailableReward,
    ButtonUnavailableReward: ButtonUnavailableReward,
    Link: Link
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PegRewardCardModal, {
    show: showPegRewardModal,
    hide: hide,
    model: modalModel,
    userPegs: userPegs
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-peg-reward-card",
    onClick: show
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-peg-reward-card__image-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: Image,
    type: 'product',
    className: "cb-card__image"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-peg-reward-card__name-container'
  }, /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    field: Name,
    className: 'cb-peg-reward-card__name cb-type-subheading-3'
  }))));
};

export default PegRewardCard;